export default __webpack_public_path__ + "static/media/hristomir.504011bf.jpg";